import React from "react";
import AudioIcon from "../../../assets/icons/white-audio.svg";
import "./AudioThumbnail.less";

interface AudioThumbnailProps {
  width?: string | number;
  height?: string | number;
  className?: string;
}

const AudioThumbnail: React.FC<AudioThumbnailProps> = ({ width = "100px", height = "162px", className = "" }) => {
  return (
    <div className={`audio-thumbnail ${className}`} style={{ width, height }}>
      <div className="audio-thumbnail-overlay">
        <img src={AudioIcon} alt="audio" className="audio-icon" />
      </div>
    </div>
  );
};

export default AudioThumbnail;
